import { render, staticRenderFns } from "./TasksAndLunch.vue?vue&type=template&id=6d8dfbc8&"
import script from "./TasksAndLunch.vue?vue&type=script&lang=js&"
export * from "./TasksAndLunch.vue?vue&type=script&lang=js&"
import style0 from "./TasksAndLunch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports